/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:16
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-07 18:02:42
 * @FilePath: \ioc_base\src\modules\assetsManage\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const routes = [{
  path: '/assets', // 消防资产主页面
  name: 'assets',
  component: () => import('@src/modules/account/main'),
  meta: {
    requireAuth: true
  },
  children: [
    {
      path: '/assets/assetsManage',  //消防资产管理主页面
      name: 'assetsManage',
      component: () => import('@src/modules/assetsManage/view/assetsManage'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    },
    {
      path: '/assets/assetsRecipient',  //消防资产归领主页面
      name: 'assetsRecipient',
      component: () => import('@src/modules/assetsManage/view/assetsRecipient'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    }
  ]

}]

export default routes
